/*
  Pokitrio-Redesign: Produktseite (Plan 4 Task 2).
  <pkt-kaufleiste form="…">: fixierte Kaufleiste auf dem Handy (snippets/pkt-sticky-kauf.liquid).
  * Sichtbar (is-visible), wenn das Ende des Kaufbereichs ([data-pkt-kaufende], die Zahlarten-Zeile unter dem
    Kaufbutton) oben aus dem Bild ist und der Footer (.pkt-ft) nicht im Bild ist. Das Formular selbst taugt nicht als
    Anker: Es ist im Kaufbereich display: contents (Menge und Button in einer Zeile) und hat keine eigene Box.
  * html.pkt-kaufleiste-an, solange sie sichtbar ist. Davon haengen in assets/pkt-produkt.css ab: Bewertungs-Pille
    und SP-Sales-Pop-Toast ausgeblendet, scroll-padding-bottom fuer den Tastaturfokus.
  * cart:error am Formular (z. B. 422 Mengenlimit): Impact setzt sein Banner vor den Hauptbutton, der weggescrollt
    ist. Steht die Leiste, zeigt sie die Meldung selbst in .pkt-kaufleiste__meldung (aria-live) fuer 6 Sekunden.
  * Nach einem Variantenwechsel ersetzt <product-rerender> das Element; das neue misst sofort neu.
  * Gemessen wird nur auf dem Handy (matchMedia '(max-width: 699px)', wie im CSS): Ab 700 px ist die Leiste per CSS
    aus, Observer, Scroll- und Resize-Listener laufen dort nicht. Ein Wechsel der Breite (change) startet bzw. stoppt
    die Messung.
  Ohne IntersectionObserver bleibt die Leiste verborgen; der Kaufbutton im Kaufbereich reicht dann.
*/
(() => {
  if (window.customElements.get('pkt-kaufleiste')) return;

  class PktKaufleiste extends HTMLElement {
    connectedCallback() {
      const id = this.getAttribute('form');
      this._form = document.getElementById(id);
      if (!this._form || !('IntersectionObserver' in window)) return;
      this._anker = document.querySelector(`[data-pkt-kaufende="${id}"]`) || this._form;
      this._fuss = document.querySelector('.pkt-ft') || document.querySelector('footer, [role="contentinfo"]');
      // Lage immer frisch messen: Der Observer meldet nur Wechsel ueber die Bildkante. Springt die Seite in einem
      // Schritt (Anker-Link, schnelles Wischen) von „unter dem Bild“ nach „ueber dem Bild“, kaeme kein Eintrag;
      // darum misst zusaetzlich ein gedrosselter Scroll-Listener (ein requestAnimationFrame je Bild).
      this._pruefen = () => {
        this._wartet = false;
        if (!this._mq || !this._mq.matches) return;
        const vorbei = this._anker.getBoundingClientRect().bottom < 0;
        const imFuss = !!this._fuss && this._fuss.getBoundingClientRect().top < window.innerHeight;
        this._zeigen(vorbei && !imFuss);
      };
      this._planen = () => {
        if (this._wartet) return;
        this._wartet = true;
        requestAnimationFrame(this._pruefen);
      };

      this._mq = window.matchMedia('(max-width: 699px)');
      this._onBreite = () => (this._mq.matches ? this._starten() : this._stoppen());
      this._mq.addEventListener('change', this._onBreite);
      if (this._mq.matches) this._starten();

      this._onFehler = (e) => this._melden(e.detail && e.detail.error);
      this._form.addEventListener('cart:error', this._onFehler);
      this._onAbsenden = () => this._melden('');
      this._form.addEventListener('submit', this._onAbsenden);
    }

    disconnectedCallback() {
      this._stoppen();
      if (this._mq) this._mq.removeEventListener('change', this._onBreite);
      if (this._form && this._onFehler) {
        this._form.removeEventListener('cart:error', this._onFehler);
        this._form.removeEventListener('submit', this._onAbsenden);
      }
      clearTimeout(this._timer);
    }

    _starten() {
      if (this._obs) return;
      this._obs = new IntersectionObserver(this._planen);
      this._obs.observe(this._anker);
      if (this._fuss) this._obs.observe(this._fuss);
      window.addEventListener('scroll', this._planen, { passive: true });
      window.addEventListener('resize', this._planen);
      this._planen();
    }

    _stoppen() {
      if (this._obs) {
        this._obs.disconnect();
        this._obs = null;
        window.removeEventListener('scroll', this._planen);
        window.removeEventListener('resize', this._planen);
      }
      this._zeigen(false);
    }

    _zeigen(an) {
      this.classList.toggle('is-visible', an);
      document.documentElement.classList.toggle('pkt-kaufleiste-an', an);
    }

    _melden(text) {
      const feld = this.querySelector('.pkt-kaufleiste__meldung');
      if (!feld) return;
      clearTimeout(this._timer);
      if (!text || !this.classList.contains('is-visible')) {
        feld.textContent = '';
        return;
      }
      feld.textContent = text;
      this._timer = setTimeout(() => { feld.textContent = ''; }, 6000);
    }
  }

  window.customElements.define('pkt-kaufleiste', PktKaufleiste);
})();
